module.exports = __webpack_public_path__ + "img/face_highrisk.2486ac94.svg";